import classNames from 'classnames';
import * as React from 'react';
import { useIntl } from 'react-intl';

import BooksStaffDescription from '../BooksStaffDescription';
import css from './BooksStaffMenu.module.scss';
import { RSButton } from 'src/reservation-page/RSButton';

interface Props {
  staffName: string;
  staffImage?: string;
  staffID?: number;
  description?: string;
  border?: string;
  postable: boolean;
  onClick?: (event: React.MouseEvent) => void;
}

const BooksStaffMenu = ({
  staffName,
  staffImage,
  staffID,
  description,
  border,
  postable,
  onClick,
}: Props) => {
  const intl = useIntl();
  const classes = classNames(css.BooksStaffMenu, {
    [css.bdTop]: border === 'top',
    [css.bdBottom]: border === 'bottom',
    [css.bdBoth]: border === 'both',
  });
  return (
    <div className={classes} data-style={description ? 'wrap' : 'noWrap'}>
      {staffImage && (
        <img
          className={css.BooksStaffMenu__Img}
          alt={staffName}
          src={staffImage}
        />
      )}
      <div
        className={css.BooksStaffMenu__Texts}
        data-style={staffImage && 'hasImage'}
      >
        <p className={css.BooksStaffMenu__Name}>{staffName}</p>
        {description && <BooksStaffDescription text={description} />}
      </div>
      <div className={css.BooksStaffMenu__Button}>
        <RSButton
          variant="outline"
          isLoading={!postable}
          disabled={!postable}
          value={staffID}
          onClick={onClick}
        >
          {intl.formatMessage({ id: 'books.button.select' })}
        </RSButton>
      </div>
    </div>
  );
};

export default BooksStaffMenu;
